import React from 'react';
import {Route, Routes} from 'react-router';
import { RoutePath } from './RoutePath';
import Home from '../pages/Home';
import BreathingDots from '../pages/BreathingDots';
import CcmExercises from '../pages/CcmExercises';

export default (
  <Routes>
    <Route path={RoutePath.Home} element={<Home />} />
    <Route path={RoutePath.BreathingDots} element={<BreathingDots />} />
    <Route path={RoutePath.CcmExercises + "/*"} element={<CcmExercises />} />
  </Routes>
);